// extracted by mini-css-extract-plugin
export default {"grid":"ProjectThumbnailsV2Grid_grid__C4UWX"};